import { NgModule } from '@angular/core'
import { AudioOrderingFeatureService } from './audio-ordering-feature.service'

@NgModule({
  providers: [AudioOrderingFeatureService],
})
export class AudioOrderingFeatureModule {}
